import React, { useEffect, useState } from "react";
import "./processBar.css";
import { useSelector, useDispatch } from "react-redux";
import {
  handleConsumption,
  handleConfiguration,
  handleElectrical,
  handleFinancial,
  handleSummary,
} from "./processBarFunction";
import { useNavigate } from "react-router-dom";
import { updateGridInfo } from "../../../Features/gridViewInfo";
import { updateQuantityInfo } from "../../../Features/quantityInfo";
import { resetDesignParameter } from "../../../Features/designParameter";

export default function ProcessBar({
  setLoader,
  screenRef,
  setEmptyValues,
  setShowMarker,
  mapRef,
  oneLineRef,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const [roofList, setRoofList] = useState(false);
  const [electrical, setElectrical] = React.useState(false);
  const [consumption, setConsumption] = React.useState(false);
  const [financial, setFinancial] = React.useState(false);
  const pathname = window.location.pathname;

  const roofInfo = useSelector((state) => state.roof);
  const handleDetail = () => {
    navigate("/createProject");
  };

  useEffect(() => {
    const screen = JSON.parse(sessionStorage.getItem("screen"));
    if (screen) {
      console.log(screen);
    }

    if (window.location.pathname === "/analytics") {
      setConsumption(true);
    } else if (window.location.pathname === "/electrical") {
      setElectrical(true);
      setConsumption(true);
    } else if (window.location.pathname === "/financial") {
      setElectrical(true);
      setConsumption(true);
      setFinancial(true);
    } else if (window.location.pathname === "/design") {
      setConsumption(true);
    } else if (window.location.pathname === "/summary") {
      setElectrical(true);
      setConsumption(true);
      setFinancial(true);
    }
  }, []);

  const handleUnit = () => {
    let unit = gridInfo.unit;
    if (gridInfo.unit === "ft") {
      unit = "m";
    } else {
      unit = "ft";
    }
    dispatch(updateGridInfo({ unit }));
  };

  return (
    <>
      <div className="processBar">
        <div className="processSection" onClick={handleDetail}>
          <div className="step">
            <div className="ellipse1">
              <div className="ellipse2"></div>
            </div>
            <i className="bi bi-check-circle-fill"></i>
          </div>
          <div className="line"></div>
          <div className="titleFrame">
            <h6>Details</h6>
          </div>
        </div>
        <div
          className="processSection"
          onClick={() => {
            if (window.location.pathname === "/createProject") {
              setShowMarker(false);
            }
            setTimeout(() => {
              handleConsumption({
                roofInfo,
                screenRef,
                setLoader,
                setEmptyValues,
                setShowMarker,
                navigate,
                dispatch,
              });
            }, 100);
          }}
        >
          <div className="step">
            <div className="ellipse1">
              <div className="ellipse2"></div>
            </div>
            <i className="bi bi-check-circle-fill"></i>
          </div>
          <div className="line"></div>
          <div className="titleFrame">
            <div>
              <h6>Consumption</h6>
              <img
                className="premium-icon"
                src={
                  consumption
                    ? "./images/assets/premium purchased.svg"
                    : "./images/assets/premium.svg"
                }
                alt="premium"
              />
            </div>
          </div>
        </div>
        <div
          className="processSection specicalSection"
          onClick={() => {
            if (window.location.pathname === "/createProject") {
              setShowMarker(false);
            }
            dispatch(updateQuantityInfo({ allRoof: false }));
            setTimeout(() => {
              handleConfiguration({
                roofInfo,
                screenRef,
                setLoader,
                setEmptyValues,
                setShowMarker,
                navigate,
                dispatch,
              });
            }, 100);
          }}
        >
          <div className="step">
            <div className="ellipse1">
              <div className="ellipse2"></div>
            </div>
            <i className="bi bi-check-circle-fill"></i>
          </div>
          <div className="line"></div>
          <div className="titleFrame">
            <h6>Design</h6>
          </div>
        </div>
        <div
          className="processSection"
          onClick={() => {
            if (window.location.pathname === "/createProject") {
              setShowMarker(false);
            }
            dispatch(resetDesignParameter());
            dispatch(updateQuantityInfo({ allRoof: true }));
            setTimeout(() => {
              handleElectrical({
                roofInfo,
                quantityInfo,
                screenRef,
                setLoader,
                setEmptyValues,
                setShowMarker,
                navigate,
                mapRef,
                dispatch,
              });
            }, 100);
          }}
        >
          <div className="step">
            <div className="ellipse1">
              <div className="ellipse2"></div>
            </div>
            <i className="bi bi-check-circle-fill"></i>
          </div>
          <div className="line"></div>
          <div className="titleFrame">
            <h6>Electricals</h6>
            <img
              className="premium-icon"
              src={
                electrical
                  ? "./images/assets/premium purchased.svg"
                  : "./images/assets/premium.svg"
              }
              alt="premium"
            />
          </div>
        </div>
        <div
          className="processSection"
          onClick={() => {
            if (window.location.pathname === "/createProject") {
              setShowMarker(false);
            }
            dispatch(resetDesignParameter());
            dispatch(updateQuantityInfo({ allRoof: true }));
            setTimeout(() => {
              handleFinancial({
                roofInfo,
                quantityInfo,
                screenRef,
                setLoader,
                setEmptyValues,
                setShowMarker,
                navigate,
                mapRef,
                oneLineRef,
                dispatch,
              });
            }, 100);
          }}
        >
          <div className="step">
            <div className="ellipse1">
              <div className="ellipse2"></div>
            </div>
            <i className="bi bi-check-circle-fill"></i>
          </div>
          <div className="line"></div>
          <div className="titleFrame">
            <div>
              <h6>Financial</h6>
              <img
                className="premium-icon"
                src={
                  financial
                    ? "./images/assets/premium purchased.svg"
                    : "./images/assets/premium.svg"
                }
                alt="premium"
              />
            </div>
          </div>
        </div>
        <div
          className="processSection"
          onClick={() => {
            if (window.location.pathname === "/createProject") {
              setShowMarker(false);
            }
            dispatch(resetDesignParameter());
            dispatch(updateQuantityInfo({ allRoof: true }));
            setTimeout(() => {
              handleSummary({
                roofInfo,
                quantityInfo,
                screenRef,
                setLoader,
                setEmptyValues,
                setShowMarker,
                navigate,
                mapRef,
                oneLineRef,
                dispatch,
              });
            }, 100);
          }}
        >
          <div className="step">
            <div className="ellipse1">
              <div className="ellipse2"></div>
            </div>
            <i className="bi bi-check-circle-fill"></i>
          </div>
          <div className="titleFrame">
            <h6>Summary</h6>
          </div>
        </div>
      </div>

      <div className="specificButton">
        <div
          className="unitParameter"
          style={pathname !== "/configuration" ? { display: "none" } : {}}
        >
          <div className="unit">
            <span
              onClick={handleUnit}
              style={
                gridInfo.unit === "ft" ? { backgroundColor: "#FF7C1B" } : {}
              }
            >
              ft
            </span>
            <span
              onClick={handleUnit}
              style={
                gridInfo.unit === "m" ? { backgroundColor: "#FF7C1B" } : {}
              }
            >
              m
            </span>
          </div>
          <h1>Change Unit</h1>
        </div>
        {roofData.length > 1 && (
          <div
            className="selectRoof"
            style={
              pathname !== "/electrical" && pathname !== "/summary"
                ? { display: "none" }
                : {}
            }
          >
            <div
              className="selectOption"
              onMouseLeave={() => setRoofList(false)}
            >
              <ul id="first" name="module" value={quantityInfo.roofNo}>
                <li
                  onClick={() => setRoofList(!roofList)}
                  className="roofSelect"
                >
                  {quantityInfo.allRoof
                    ? `All Roof`
                    : `Roof ${quantityInfo.roofNo + 1}`}
                  <i className="bi bi-caret-down-fill"></i>
                </li>

                {roofList && (
                  <div
                    className="dropDown"
                    onMouseLeave={() => setRoofList(false)}
                  >
                    {((quantityInfo.electricalConfiguration === "All Roof" &&
                      pathname === "/electrical") ||
                      pathname === "/summary") && (
                      <div
                        className={"roofContainer"}
                        onClick={() => {
                          setRoofList(false);
                          dispatch(updateQuantityInfo({ allRoof: true }));
                        }}
                      >
                        <img src={"../images/icons/roof.png"} alt={"roof"} />
                        <h2>All Roof</h2>
                      </div>
                    )}
                    {roofData &&
                      ((quantityInfo.electricalConfiguration ===
                        "Single Roof" &&
                        pathname === "/electrical") ||
                        pathname === "/summary") &&
                      roofData.map((item, i) => (
                        <div
                          className={"roofContainer"}
                          onClick={() => {
                            setRoofList(false);
                            dispatch(
                              updateQuantityInfo({ roofNo: i, allRoof: false })
                            );
                          }}
                          key={i}
                        >
                          <img src={"../images/icons/roof.png"} alt={"roof"} />
                          <h2>Roof {i + 1}</h2>
                        </div>
                      ))}
                  </div>
                )}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
